export default __webpack_public_path__ + "src/assets/tasks/wordchaos/ordkaos_lydfil_kaos.mp3";